import { Tab, TabContext, TabList } from '@shared/components';

import { ItemAnalysisTab, type ItemAnalysisTabType } from '../../constants';
import { useItemAnalysisSearchParams } from '../../hooks';

interface TabItem {
  value: ItemAnalysisTabType;
  label: string;
}

const TAB_LIST: TabItem[] = [
  {
    value: ItemAnalysisTab.QBankOverview,
    label: 'QBank Overview',
  },
  {
    value: ItemAnalysisTab.ResponseStatistics,
    label: 'Response Statistics',
  },
  {
    value: ItemAnalysisTab.DiscriminantAnalysis,
    label: 'Discriminant Analysis',
  },
  {
    value: ItemAnalysisTab.PAnalysis,
    label: 'P Analysis',
  },
];

export default function ItemAnalysisNavigationTabs() {
  const [{ navigationTab }, { changeNavigationTab }] = useItemAnalysisSearchParams();
  const handleClick = (value: ItemAnalysisTabType) => {
    changeNavigationTab(value);
  };

  return (
    <TabContext value={navigationTab}>
      <TabList
        sx={(theme) => ({
          gap: theme.spacing(0),

          '& .MuiTabs-flexContainer': {
            gap: theme.spacing(4),
          },
          borderBottom: `1px solid ${theme.palette.divider}`,
        })}
      >
        {TAB_LIST.map((tab) => {
          return (
            <Tab
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(0),
                p: theme.spacing(1, 1.5),
                minWidth: 'unset',
                ':hover': { backgroundColor: 'transparent' },
              })}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
